import { PaymentDisplayModel, AnfrageDisplayModel, GlobalEnumerationsAceMittelabruf, PaymentFoerdersummenDisplayModel, PaymentFoerdersummenDisplayModelFormGroup, LocalizedTextDisplayModel } from '@/api/model-index';
import { ActivatedRoute } from '@angular/router';
import { Component, inject, Type } from '@angular/core';
import { PortalkonfigurationDisplayModel } from '../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { NavigationService } from '@/core/services/navigation.service';
import { I18nService } from '@/core/services/i18nService';
import { PaymentService } from '@/core/services/payment.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { PendingAmountsComponent } from '../../components/pending-amounts/pending-amounts.component';
import { FundingTableComponent } from '../../components/funding-table/funding-table.component';
import { ComponentService } from '@/core/services/component.service';

@Component({
    selector: 'app-anfrage-fund-payments',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent {
    public anfrage: AnfrageDisplayModel;
    public payments: PaymentDisplayModel[] = [];
    public fundingAmounts: PaymentFoerdersummenDisplayModel;
    public fundingAmountsForm: PaymentFoerdersummenDisplayModelFormGroup;
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    public type: GlobalEnumerationsAceMittelabruf = GlobalEnumerationsAceMittelabruf.Zahlung;
    public portalContextService: PortalContextService = inject(PortalContextService);
    protected componentService = inject(ComponentService);

    constructor(protected route: ActivatedRoute,
        protected languageservice: I18nService,
        protected navigationService: NavigationService,
        protected paymentService: PaymentService,
    ) {

        this.anfrage = this.portalContextService.CurrentAnfrage;
        this.fundingAmounts = this.route.snapshot.data.fundingAmounts;
        this.payments = this.fundingAmounts.payments ?? [];
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
    }

    public get abschnittInfotext(): string {
        let infotext: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.mittelabrufAbschnitt?.infotext);
        return infotext?.text ?? "";
    }

    public get pendingAmountsComponent(): Type<PendingAmountsComponent> {
        return this.componentService.get(PendingAmountsComponent);
    }

    public get fundingTableComponent(): Type<FundingTableComponent> {
        return this.componentService.get(FundingTableComponent);
    }
}